import React from 'react'
import { Box, css, Flex, styled, Text } from '@chilipiper/design-system'
import { Icon } from '@chilipiper/design-system/src/new'

type Props = {
  icon: React.ComponentType | React.ReactNode
  isActive?: boolean
  isExpanded?: boolean
  label: string
  sublabel?: string
  rightIcon?: React.ComponentType
}

export const NavItem = ({
  isActive = false,
  icon,
  label,
  sublabel,
  rightIcon,
  isExpanded = true,
}: Props) => (
  <NavItemWrapper isActive={isActive} gap={3} px={3} borderRadius={10}>
    {typeof icon === 'function' ? (
      <Icon flexShrink={0} icon={icon} color={isActive ? 'fg/major-on-color' : 'fg/moderate'} />
    ) : (
      icon
    )}
    {isExpanded && (
      <>
        <Box flex={1} minWidth={0}>
          <Text
            display='block'
            color={isActive ? 'fg/major-on-color' : 'fg/major'}
            textStyle={isActive ? 'item-selected' : 'item-unselected'}
            whiteSpace='nowrap'
            overflow='hidden'
            textOverflow='ellipsis'
          >
            {label}
          </Text>
          {sublabel && (
            <Text
              display='block'
              color='fg/moderate'
              textStyle='detail-m'
              whiteSpace='nowrap'
              overflow='hidden'
              textOverflow='ellipsis'
            >
              {sublabel}
            </Text>
          )}
        </Box>
        {rightIcon && <Icon flexShrink={0} icon={rightIcon} color='fg/moderate' />}
      </>
    )}
  </NavItemWrapper>
)

const NavItemWrapper = styled(Flex)<{ isActive?: boolean }>`
  transition: 0.2s;
  align-items: center;
  width: 100%;
  min-height: 40px;

  ${({ isActive, theme }) =>
    isActive
      ? css`
          background: ${theme.colors['bg/brand-emphasis']};
        `
      : css`
          :hover {
            background: ${theme.colors['bg/list-item-hovered']};
          }
        `}
`
